const NAMESPACE = "messageInfo";

const KEYS = {
    fromLabel: "fromLabel",
    replyToDisplayNameLabel: "replyToDisplayNameLabel",
    replyToEmailLabel: "replyToEmailLabel",
    useDefaultCheckboxLabel: "useDefaultCheckboxLabel",
    toLabel: "toLabel",
    ccLabel: "ccLabel",
    bccLabel: "bccLabel",
    subjectLabel: "subjectLabel",
    attachmentsLabel: "attachmentsLabel",
    attachmentsNoneText: "attachmentsNoneText",
    attachmentDeleteBtnLabel: "attachmentDeleteBtnLabel",
    attachmentAddBtnLabel: "attachmentAddBtnLabel",
    contentItemAddBtnLabel: "contentItemAddBtnLabel",
    addAttachmentDialogHeader: "addAttachmentDialogHeader",
    addAttachmentDialogCancel: "addAttachmentDialogCancel",
    addAttachmentDialogOk: "addAttachmentDialogOk",
    messageToValidationErrorMessage: "messageToValidationErrorMessage",
    messageSubjectValidationErrorMessage: "messageSubjectValidationErrorMessage",
    messageTopicValidationErrorMessage: "messageTopicValidationErrorMessage",
    cannotDownloadSensitiveAttachmentDialogHeader: "cannotDownloadSensitiveAttachmentDialogHeader",
    cannotDownloadSensitiveAttachmentDialogText: "cannotDownloadSensitiveAttachmentDialogText",
    cannotDownloadSensitiveAttachmentDialogCloseBtnLabel: "cannotDownloadSensitiveAttachmentDialogCloseBtnLabel",
    printCommunicationDateLabel: "printCommunicationDateLabel",
    contentItemLabel: "contentItemLabel",
    createNewTopicButtonLabel: "createNewTopicButtonLabel",
    announcementTopicLabel: "announcementTopicLabel",
    communicationTopicDefaultOptionText: "communicationTopicDefaultOptionText"
};

const MESSAGES = {
    [KEYS.fromLabel]: { value: "From:", comment: "Label of the 'from' field for this message" },
    [KEYS.replyToDisplayNameLabel]: {
        value: "Reply-To Display Name:",
        comment: "Label of the 'reply-to display name' field for this message"
    },
    [KEYS.replyToEmailLabel]: {
        value: "Reply-To Email Address:",
        comment: "Label of the 'reply-to email address' field for this message"
    },
    [KEYS.useDefaultCheckboxLabel]: {
        value: "Use Default",
        comment:
            "Label for the checkboxes that allow user to specify whether they want to use the default reply-to email and display name"
    },
    [KEYS.toLabel]: { value: "To:", comment: "Label of the 'To' field for this message" },
    [KEYS.ccLabel]: { value: "Cc:", comment: "Label of the 'Cc' field for this message" },
    [KEYS.bccLabel]: { value: "Bcc:", comment: "Label of the  'Bcc' field for this message" },
    [KEYS.subjectLabel]: { value: "Subject:", comment: "Label of the 'Subject' field for this message" },
    [KEYS.attachmentsLabel]: {
        value: "Attachments:",
        comment:
            "Label for the area that allows users to add, remove, or view the current attachments included with this communication"
    },
    [KEYS.attachmentsNoneText]: {
        value: "None",
        comment: "Text that displays in the attachments area when there are no attachments present"
    },
    [KEYS.attachmentDeleteBtnLabel]: {
        value: "Delete",
        comment: "Label for the button that allows users to remove an attachment from the message"
    },
    [KEYS.attachmentAddBtnLabel]: {
        value: "Add Project Attachment...",
        comment: "Label for the button that allows users to add attachments to the communication"
    },
    [KEYS.contentItemAddBtnLabel]: {
        value: "Add Content Library Item...",
        comment: "Label for the button that allows users to add content items to the communication"
    },
    [KEYS.addAttachmentDialogHeader]: {
        value: "Add Attachment to Communication",
        comment: "Title of the dialog where users select a new attachment to add to the communication"
    },
    [KEYS.addAttachmentDialogCancel]: {
        value: "Cancel",
        comment: "Label for the button that cancels adding a new attachment to the communication"
    },
    [KEYS.addAttachmentDialogOk]: {
        value: "OK",
        comment: "Label for the button that completes adding an attachment to the communication"
    },
    [KEYS.messageToValidationErrorMessage]: {
        value: "Please specify a recipient email.",
        comment:
            "Validation error that appears if the user does not specify anything in the 'to' field for the communication"
    },
    [KEYS.messageSubjectValidationErrorMessage]: {
        value: "Please specify a communication subject.",
        comment: "Validation error that appears if the user doesn't specify a communication subject"
    },
    [KEYS.messageTopicValidationErrorMessage]: {
        value: "Please specify an announcement topic.",
        comment: "Validation error that appears if the user doesn't specify an announcement topic"
    },
    [KEYS.cannotDownloadSensitiveAttachmentDialogHeader]: {
        value: "Cannot download attachment",
        comment:
            "Header for the dialog that informs the user they cannot download a sensitive attachment that was attached to the communication"
    },
    [KEYS.cannotDownloadSensitiveAttachmentDialogText]: {
        value: "This is a sensitive attachment and your role does not have the privilege to view sensitive data.",
        comment:
            "Explanatory text explaining to the user that they cannot download the sensitive attachment for the communication because they lack the proper permission"
    },
    [KEYS.cannotDownloadSensitiveAttachmentDialogCloseBtnLabel]: {
        value: "Close",
        comment:
            "Label for the button that closes the dialog informing the user they can't download a sensitive attachment"
    },
    [KEYS.printCommunicationDateLabel]: {
        value: "Date Printed:",
        comment:
            "Label for the date information included as part of the minimal, printer-friendly rendering of the communication"
    },
    [KEYS.contentItemLabel]: {
        value: "Content Item: ",
        comment: "Label for the content item added to communication."
    },
    [KEYS.createNewTopicButtonLabel]: {
        value: "Create New Topic",
        comment: "Button label for creating a new topic from the edit communication template page"
    },
    [KEYS.announcementTopicLabel]: {
        value: "Announcement Topic:",
        comment: "Label for the announcement topic field of the message"
    },
    [KEYS.communicationTopicDefaultOptionText]: {
        value: "Select a topic...",
        comment: "Text of default option in selector for the announcement topic field of the message"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
